// How a large figure is said on the Cierres screens. PURE.
//
// "$1.562.396.149.510,30" is exact but hard to read aloud, and many people do not know how to say it.
// The screens print the exact figure and, small beneath it, the same figure in words of the Colombian
// long scale: "1,56 billones de pesos". Mil millones is 10⁹ and a billón 10¹², never the English
// billion. The chart axes use the short form of the same scale ("80 mil M"), never "80.0MM".

const ESCALAS = [
  { desde: 1e12, uno: "billón", varios: "billones", corto: "B" },
  { desde: 1e9, uno: "mil millones", varios: "mil millones", corto: "mil M" },
  { desde: 1e6, uno: "millón", varios: "millones", corto: "M" },
  { desde: 1e3, uno: "mil", varios: "mil", corto: "mil" },
];

/** Up to `decimales` decimals, Colombian separators, no trailing zeros: 1,56 · 607,9 · 75. */
const corto = (n, decimales) => n.toLocaleString("es-CO", { maximumFractionDigits: decimales });

/**
 * A figure in words, for a person who cannot read "1.562.396.149.510": "1,56 billones de pesos",
 * "607,95 millones de pesos", "1,23 millones". Null below ten thousand, which is read at a glance.
 */
export function cifraEnPalabras(valor, { pesos = false } = {}) {
  const n = Number(valor);
  if (!Number.isFinite(n) || Math.abs(n) < 1e4) return null;
  const escala = ESCALAS.find((e) => Math.abs(n) >= e.desde);
  const cuanto = n / escala.desde;
  const decimales = 2;
  const redondo = Number(cuanto.toFixed(decimales));
  const palabra = Math.abs(redondo) === 1 ? escala.uno : escala.varios;
  const texto = `${corto(redondo, decimales)} ${palabra}`;
  return pesos ? `${texto} de pesos` : texto;
}

/** A chart axis tick in the same scale, short: "80 mil M", "60 M", "75 mil", "1,5 B". */
export function ejeCorto(valor) {
  const n = Number(valor);
  if (!Number.isFinite(n)) return "";
  const escala = ESCALAS.find((e) => Math.abs(n) >= e.desde);
  if (!escala) return corto(n, 0);
  return `${corto(n / escala.desde, 1)} ${escala.corto}`;
}

/**
 * The size a card's figure is drawn at, by how long it is written, so "$1.562.396.149.510,30" fits its
 * card instead of running out of it. The card also wraps it as a last resort.
 */
export function tamanoDeCifra(texto) {
  const largo = String(texto || "").length;
  if (largo <= 10) return "text-[26px]";
  if (largo <= 14) return "text-[22px]";
  if (largo <= 18) return "text-[19px]";
  return "text-[17px]";
}
